module.exports = __webpack_public_path__ + "static/media/Beach2.83bc3619.jpg";